// Shared location filter (country + city) persisted across the Search and
// Episodes browse screens. Setting a country/city on one page carries over to
// the other, and the choice survives navigation (the pages are reached from the
// nav, which resets any URL search params). `country` is a canonical ISO-2 code
// so both pages agree regardless of how they render it (Search uses codes,
// Episodes uses display names and converts at its boundary).
const KEY = "ohlala_geo_filter_v1";

export type GeoFilter = { country: string; city: string };

export function readGeoFilter(): GeoFilter | null {
  if (typeof window === "undefined") return null;
  try {
    const o = JSON.parse(localStorage.getItem(KEY) ?? "null");
    if (!o || typeof o !== "object") return null;
    return {
      country: typeof o.country === "string" ? o.country : "",
      city: typeof o.city === "string" ? o.city : "",
    };
  } catch {
    return null;
  }
}

/**
 * Event name for same-document listeners. `storage` fires in OTHER tabs only —
 * by spec, never in the document that wrote the value — so anything living
 * alongside the writer (the header's location chip sits in the persistent app
 * layout, which does not remount on an SPA navigation) would never learn the
 * filter had changed and would show the old city for the rest of the session.
 */
export const GEO_FILTER_EVENT = "ohlala:geo-filter";

export function writeGeoFilter(f: GeoFilter): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ country: f.country ?? "", city: f.city ?? "" }));
    window.dispatchEvent(new Event(GEO_FILTER_EVENT));
  } catch {
    /* ignore */
  }
}
